import React, { useState } from "react";
import styles from "./CommentaireTimeline.module.scss";
import tools from "../../../../../helpers/tools";

const CommentaireTimeline = ({ commentaireHistorique, onAddCommentaire }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newComment, setNewComment] = useState("");

  const handleAddComment = () => {
    if (newComment.trim() && onAddCommentaire) {
      onAddCommentaire({ commentaire: newComment.trim() });
      setNewComment("");
      setShowAddForm(false);
    }
  };

  const handleCancel = () => {
    setNewComment("");
    setShowAddForm(false);
  };

  // if (!commentaireHistorique || commentaireHistorique.length === 0) {
  //   return (
  //     <div className={styles.timelineEmpty}>
  //       <i className="fas fa-comments text-muted mr-2"></i>
  //       <span className="text-muted">Aucun commentaire disponible</span>
  //     </div>
  //   );
  // }

  const sortedDateDescCommentaires = commentaireHistorique.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );

  return (
    <div className={styles.timeline}>
      {/* Formulaire d'ajout de commentaire */}
      {onAddCommentaire && (
        <div
          className={`${styles.timelineItem} ${
            commentaireHistorique.length === 0 ? styles.last : ""
          }`}
        >
          {/* Timeline date */}
          <div className={styles.timelineDate}>
            {/* <small className="text-muted">{tools.formatDate(new Date())}</small> */}
          </div>

          {/* Timeline connector */}
          <div className={styles.timelineConnector}>
            <div
              className={`${styles.timelineDot}`}
              style={{ background: "#28a745" }}
            >
              <i className="fas fa-plus"></i>
            </div>
            {(commentaireHistorique.length > 0 || showAddForm) && (
              <div className={styles.timelineLine}></div>
            )}
          </div>

          {/* Timeline content */}
          <div className={`${styles.timelineContent}`}>
            {!showAddForm ? (
              <button
                className="btn btn-sm btn-default  mb-0 mt-1 text-lowercase"
                onClick={() => setShowAddForm(true)}
              >
                <i className="fas fa-plus mr-1"></i>
                Ajouter un commentaire
              </button>
            ) : (
              <div className={styles.timelineComment}>
                <div className="mb-2">
                  <textarea
                    className="form-control form-control-sm rounded"
                    placeholder="Saisir votre commentaire..."
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    rows={3}
                    style={{ resize: "vertical", minHeight: "60px" }}
                    autoFocus
                  />
                </div>
                <div className="d-flex" style={{ gap: "0.5rem" }}>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleAddComment}
                    disabled={!newComment.trim()}
                  >
                    <i className="fas fa-check mr-1"></i>
                    Envoyer
                  </button>
                  <button
                    className="btn btn-sm btn-default shadow-none border-0"
                    onClick={handleCancel}
                  >
                    <i className="fas fa-times mr-1"></i>
                    Annuler
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Timeline des commentaires existants */}
      {sortedDateDescCommentaires.map((item, index) => (
        <div
          key={index}
          className={`${styles.timelineItem} ${
            index === commentaireHistorique.length - 1 ? styles.last : ""
          }`}
        >
          {/* Timeline date */}
          <div className={styles.timelineDate}>
            <small className="text-muted">
              {tools.formatDate(item.created_at)}
            </small>
          </div>

          {/* Timeline connector */}
          <div className={styles.timelineConnector}>
            <div className={styles.timelineDot}>
              <i className="fas fa-comment"></i>
            </div>
            {index < commentaireHistorique.length - 1 && (
              <div className={styles.timelineLine}></div>
            )}
          </div>

          {/* Timeline content */}
          <div className={styles.timelineContent}>
            <div className={styles.timelineHeader}>
              <div className={styles.timelineUser}>
                <i className="fas fa-user text-muted mr-1"></i>
                <span className="text-dark font-weight-medium">{item.nom}</span>
              </div>
            </div>

            <div className={styles.timelineComment}>
              <p className="mb-0">{item.commentaire}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommentaireTimeline;
